import { render, staticRenderFns } from "./butList.vue?vue&type=template&id=674bec58&scoped=true"
import script from "./butList.vue?vue&type=script&lang=js"
export * from "./butList.vue?vue&type=script&lang=js"
import style0 from "./butList.vue?vue&type=style&index=0&id=674bec58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674bec58",
  null
  
)

export default component.exports